<template>
    <div></div>
</template>

<script>
    import SubscriptionRepository from '../../repositories/subscription';
   import ReferalRepository from '../../repositories/referalProgram';
    import PostAfiliatesUtilites from '../../services/referalProgramUtiliities';
    export default {
        name: "PaymentEvent",
        mounted() {
            this.init();
        },
        methods: {
            async trackSalePostAffiliate(){
                if(this.$route.query.session_id!=undefined){
                    await SubscriptionRepository.getPayment(this.$route.query.session_id).then((response)=>{
                        if (response.status < 400) {
                                if(response.data.status=='ACTIVATED'){
                                    const postAfiliateCampaingId = this.$store.state.whitelabel.partner !== null ? process.env.VUE_APP_POSTAFFILIATE_WL_CAMPAIGN_ID:process.env.VUE_APP_POSTAFFILIATE_CAMPAIGN_ID;
                                    PostAfiliatesUtilites.paymentTracking(this.$store.state.user.details.referredFrom,postAfiliateCampaingId,response.data.session_reference,response.data.amount);
                            }
                        
                        }
                })
                }
            },
            async init() {
                let eventType = this.$route.query.event;
                if(eventType === 'success') {
                    if(this.$store.state.user.details.referredFrom!=undefined){
                        try{
                            await ReferalRepository.getReferrer(this.$store.state.user.details.referredFrom).then((response)=>{
                                if(response.status < 400) {
                                    if (response.data == true) {
                                        this.trackSalePostAffiliate();
                                    }
                                }
                            });
                        }catch(err){
                            // eslint-disable-next-line no-console
                            console.log(err);
                        }
                    }
                    this.$router.push({
                                name: 'confirmation',
                                params: { titleMessage: this.$t('success.titleMessage'),
                                    bodyMessage: this.$t('success.bodyMessage'),
                                    goToMessage: this.$t('success.goToMessage'),
                                    afterConfirmationRoute: 'dashboard'
                                    }
                            });
                }
                else {
                    this.$router.push({
                        name: 'confirmation',
                        params: { titleMessage: this.$t('failure.titleMessage'),
                            bodyMessage: this.$t('failure.bodyMessage'),
                            goToMessage: this.$t('failure.goToMessage'),
                            afterConfirmationRoute: 'subscription-plans'}
                    });
                }
            },
        }
    }
</script>

<style scoped>

</style>


